import React, { FC } from 'react';
import { Button, ButtonPriority } from 'wix-ui-tpa/cssVars';
import { Filter } from '@wix/wix-ui-icons-common/on-stage';
import { classes } from './FilterButton.st.css';

export const DataHooks = {
  ROOT: 'filter-button',
};

export interface FilterButtonProps {
  onClick: () => void;
}

export const FilterButton: FC<FilterButtonProps> = ({ onClick }) => {
  return (
    <div className={classes.root} data-hook={DataHooks.ROOT}>
      <Button
        upgrade
        prefixIcon={<Filter />}
        onClick={onClick}
        priority={ButtonPriority.secondary}
        aria-label="Filter services"
      >
        Filter
      </Button>
    </div>
  );
};
